import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface AchievementBadgeProps {
  name: string;
  description: string;
  unlocked: boolean;
  size?: 'sm' | 'md';
}

export default function AchievementBadge({
  name,
  description,
  unlocked,
  size = 'md'
}: AchievementBadgeProps) {
  return (
    <Card
      className={cn(
        "p-4 transition-all",
        unlocked ? "border-primary/50 bg-primary/5" : "opacity-50",
        size === 'sm' && "p-3"
      )}
      data-testid={`achievement-${name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className="space-y-1">
        <div className="flex-1 min-w-0">
          <h4 className={cn("font-semibold truncate", size === 'sm' && "text-sm")}>{name}</h4>
          <p className={cn("text-muted-foreground truncate", size === 'sm' ? "text-xs" : "text-sm")}>
            {description}
          </p>
        </div>
      </div>
    </Card>
  );
}
